import { render, staticRenderFns } from "./followRef.vue?vue&type=template&id=58deceb6&scoped=true"
import script from "./followRef.vue?vue&type=script&lang=js"
export * from "./followRef.vue?vue&type=script&lang=js"
import style0 from "./followRef.vue?vue&type=style&index=0&id=58deceb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58deceb6",
  null
  
)

export default component.exports